import React from 'react'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'
import MoveOrderModal from './components/MoveOrderModal'
import NiceModal  from '@ebay/nice-modal-react'
import { useHistory } from 'react-router-dom'

const MoveOrder = ({ order, refetch, readOnly }) => {
  const history = useHistory()
  const { formatMessage } = useIntl()

  return (
    <Menu.Item state="negative">
      {(props) => (
        <MenuButton history={history} {...props} disabled={readOnly} onClick={() => NiceModal.show(MoveOrderModal, { refetch: refetch, orderId: order.uid, dealId: order.deal_id })}>
          { formatMessage(messages.title) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default MoveOrder
